(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["SimpleKeyboard"] = factory();
	else
		root["SimpleKeyboard"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Keyboard__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__components_Keyboard__["a" /* default */]);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Keyboard_css__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Keyboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Keyboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_KeyboardLayout__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Utilities__ = __webpack_require__(5);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}// Services
var SimpleKeyboard=function SimpleKeyboard(){_classCallCheck(this,SimpleKeyboard);_initialiseProps.call(this);var keyboardDOMQuery=typeof(arguments.length<=0?undefined:arguments[0])==="string"?arguments.length<=0?undefined:arguments[0]:'.simple-keyboard';var options=_typeof(arguments.length<=0?undefined:arguments[0])==="object"?arguments.length<=0?undefined:arguments[0]:arguments.length<=1?undefined:arguments[1];if(!options)options={};/**
     * Processing options
     */this.keyboardDOM=document.querySelector(keyboardDOMQuery);this.options=options;this.options.layoutName=this.options.layoutName||"default";this.options.theme=this.options.theme||"hg-theme-default";this.options.inputName=this.options.inputName||"default";this.input={};this.input[this.options.inputName]='';/**
     * Rendering keyboard
     */if(this.keyboardDOM)this.render();else console.error('"'+keyboardDOMQuery+'" was not found in the DOM.');};var _initialiseProps=function _initialiseProps(){var _this=this;this.handleButtonClicked=function(button){var debug=_this.options.debug;/**
     * Ignoring placeholder buttons
     */if(button==='{//}')return false;/**
     * Calling onKeyPress
     */if(typeof _this.options.onKeyPress==="function")_this.options.onKeyPress(button);/**
     * Updating input
     */var options={newLineOnEnter:_this.options.newLineOnEnter===true};if(!_this.input[_this.options.inputName])_this.input[_this.options.inputName]='';var updatedInput=__WEBPACK_IMPORTED_MODULE_2__services_Utilities__["a" /* default */].getUpdatedInput(button,_this.input[_this.options.inputName],options);if(_this.input[_this.options.inputName]!==updatedInput){_this.input[_this.options.inputName]=updatedInput;if(debug)console.log('Input changed:',_this.input);/**
       * Calling onChange
       */if(typeof _this.options.onChange==="function")_this.options.onChange(_this.input[_this.options.inputName]);}if(debug){console.log("Key pressed:",button);}};this.clearInput=function(inputName){inputName=inputName||_this.options.inputName;_this.input[_this.options.inputName]='';};this.getInput=function(inputName){inputName=inputName||_this.options.inputName;return _this.input[_this.options.inputName];};this.setInput=function(input,inputName){inputName=inputName||_this.options.inputName;_this.input[inputName]=input;};this.setOptions=function(option){option=option||{};_this.options=Object.assign(_this.options,option);_this.render();};this.clear=function(){_this.keyboardDOM.innerHTML='';};this.render=function(){/**
     * Clear keyboard
     */_this.clear();var layoutClass=_this.options.layout?"hg-layout-custom":'hg-layout-'+_this.options.layoutName;var layout=_this.options.layout||__WEBPACK_IMPORTED_MODULE_1__services_KeyboardLayout__["a" /* default */].getLayout(_this.options.layoutName);/**
     * Account for buttonTheme, if set
     */var buttonThemesParsed={};if(Array.isArray(_this.options.buttonTheme)){_this.options.buttonTheme.forEach(function(themeObj){if(themeObj.buttons&&themeObj.class){var themeButtons=themeObj.buttons.split(' ');if(Array.isArray(themeButtons)){themeButtons.forEach(function(themeButton){var themeParsed=buttonThemesParsed[themeButton];// If the button has already been added
if(themeParsed)buttonThemesParsed[themeButton]=themeParsed+' '+themeObj.class;else buttonThemesParsed[themeButton]=themeObj.class;});}}else{console.warn('buttonTheme row is missing the "buttons" or the "class". Please check the documentation.');}});}/**
     * Adding themeClass, layoutClass to keyboardDOM
     */_this.keyboardDOM.className+=' '+_this.options.theme+' '+layoutClass;/**
     * Iterating through each row
     */layout[_this.options.layoutName].forEach(function(row){var rowArray=row.split(' ');/**
       * Creating empty row
       */var rowDOM=document.createElement('div');rowDOM.className+="hg-row";/**
       * Iterating through each button in row
       */rowArray.forEach(function(button){var fctBtnClass=__WEBPACK_IMPORTED_MODULE_2__services_Utilities__["a" /* default */].getButtonClass(button);var buttonThemeClass=buttonThemesParsed[button];var buttonDisplayName=__WEBPACK_IMPORTED_MODULE_2__services_Utilities__["a" /* default */].getButtonDisplayName(button,_this.options.display);/**
         * Creating button
         */var buttonDOM=document.createElement('div');buttonDOM.className+='hg-button '+fctBtnClass+(buttonThemeClass?" "+buttonThemeClass:"");buttonDOM.onclick=function(){return _this.handleButtonClicked(button);};/**
         * Adding button label to button
         */var buttonSpanDOM=document.createElement('span');buttonSpanDOM.innerHTML=buttonDisplayName;buttonDOM.appendChild(buttonSpanDOM);/**
         * Appending button to row
         */rowDOM.appendChild(buttonDOM);/**
         * Calling onInit
         */if(typeof _this.options.onInit==="function")_this.options.onInit();});/**
       * Appending row to keyboard
       */_this.keyboardDOM.appendChild(rowDOM);});};};/* harmony default export */ __webpack_exports__["a"] = (SimpleKeyboard);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var KeyboardLayout=function KeyboardLayout(){_classCallCheck(this,KeyboardLayout);};KeyboardLayout.getLayout=function(layout){if(layout==="qwerty"){return{'default':['` 1 2 3 4 5 6 7 8 9 0 - = {bksp}','{tab} q w e r t y u i o p [ ] \\','{lock} a s d f g h j k l ; \' {enter}','{shift} z x c v b n m , . / {shift}','.com @ {space}'],'shift':['~ ! @ # $ % ^ & * ( ) _ + {bksp}','{tab} Q W E R T Y U I O P { } |','{lock} A S D F G H J K L : " {enter}','{shift} Z X C V B N M < > ? {shift}','.com @ {space}']};}else if(layout==="numeric"){return{'default':['1 2 3','4 5 6','7 8 9','{//} 0 {bksp}']};}else{return KeyboardLayout.getLayout("qwerty");}};/* harmony default export */ __webpack_exports__["a"] = (KeyboardLayout);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Utilities=function(){function Utilities(){_classCallCheck(this,Utilities);}_createClass(Utilities,null,[{key:"normalizeString",value:function normalizeString(string){var output=void 0;if(string==="@")output='at';else if(string===",")output='comma';else if(string===".")output='dot';else if(string==="\\")output='backslash';else if(string==="/")output='fordardslash';else if(string==="*")output='asterisk';else if(string==="&")output='ampersand';else if(string==="$")output='dollarsign';else if(string==="=")output='equals';else if(string==="+")output='plus';else if(string==="-")output='minus';else if(string==="'")output='apostrophe';else if(string===";")output='colon';else if(string==="[")output='openbracket';else if(string==="]")output='closebracket';else if(string==="//")output='emptybutton';else output='';return output?" hg-button-"+output:'';}},{key:"getDefaultDiplay",value:function getDefaultDiplay(){return{'{bksp}':'backspace','{enter}':'< enter','{shift}':'shift','{s}':'shift','{tab}':'tab','{lock}':'caps','{accept}':'Submit','{space}':' ','{//}':' '};}}]);return Utilities;}();Utilities.getButtonClass=function(button){var buttonTypeClass=button.includes("{")&&button!=='{//}'?"functionBtn":"standardBtn";var buttonWithoutBraces=button.replace("{","").replace("}","");var buttonNormalized=buttonTypeClass==="standardBtn"?Utilities.normalizeString(buttonWithoutBraces):" hg-button-"+buttonWithoutBraces;return"hg-"+buttonTypeClass+buttonNormalized;};Utilities.getButtonDisplayName=function(button,display){display=display||Utilities.getDefaultDiplay();return display[button]||button;};Utilities.getUpdatedInput=function(button,input,options){var output=input;var newLineOnEnter=options.newLineOnEnter;if(button==="{bksp}"&&output.length>0)output=output.slice(0,-1);else if(button==="{space}")output=output+' ';else if(button==="{tab}")output=output+"\t";else if(button==="{enter}"&&newLineOnEnter)output=output+"\n";else if(!button.includes("{")&&!button.includes("}"))output=output+button;return output;};/* harmony default export */ __webpack_exports__["a"] = (Utilities);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js